import { useState } from 'react'
import {
  deleteTestsOfOneProcess,
  deleteUsersOfOneProcess,
} from 'services/common/process/createProcess/create-process-service'
import { useNotification } from 'lib/context/notification.context'

type ApiResponse = {
  status: string
  error?: { response?: { data?: { message?: string } } }
}

type UseDeleteUsersInProcessResponse = {
  loadingDeleteUsersInProcess: boolean
  error: boolean
  success: boolean
  deleteUsersInProcess: (processId: number, usersIds: number[]) => Promise<boolean>
  deleteTestsInProcess: (processId: number) => Promise<void>
}

const useDeleteUsersInProcess = (): UseDeleteUsersInProcessResponse => {
  const { getError, getSuccess } = useNotification()

  const [loadingDeleteUsersInProcess, setLoading] = useState(false)
  const [errorDeleteUsersInProcess, setError] = useState(false)
  const [successDeleteUsersInProcess, setSuccess] = useState(false)

  const deleteUsersInProcess = async (processId: number, usersIds: number[]): Promise<boolean> => {
    setLoading(true)
    setError(false)
    setSuccess(false)

    try {
      const response: ApiResponse = await deleteUsersOfOneProcess(processId, usersIds)
      if (response.status !== 'OK') {
        setError(true)
        getError(response.error?.response?.data?.message || 'No se pudo eliminar al usuario del proceso.')
        return false
      }
      setSuccess(true)
      getSuccess(` ${usersIds.length} usuarios eliminados correctamente`)
      return true
    } catch {
      setError(true)
      getError('No se pudo eliminar al usuario del proceso.')
      return false
    } finally {
      setLoading(false)
    }
  }

  const deleteTestsInProcess = async (processId: number) => {
    const response: ApiResponse = await deleteTestsOfOneProcess(processId)

    if (response.status === 'OK') {
      setSuccess(true)
    }
  }

  return {
    loadingDeleteUsersInProcess,
    error: errorDeleteUsersInProcess,
    success: successDeleteUsersInProcess,
    deleteUsersInProcess,
    deleteTestsInProcess,
  }
}

export default useDeleteUsersInProcess
